import styled from 'styled-components'

const Layout = styled.div`
  height: fit-content;
  width: 100%;
  max-width: 936px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`
export default Layout
